import { DELETABLE_NODE_TYPES } from '../constants';
import { type AppNode } from '../types';

export const selectDeletableCanvasNodes = (nodes: AppNode[], reactFlowSelectedIds: ReadonlySet<string>): AppNode[] =>
  nodes.filter((node) => DELETABLE_NODE_TYPES.has(node.type) && (node.selected || reactFlowSelectedIds.has(node.id)));
